import { companyImage } from '@/utils/common/env.constants';
import { ProfileImageBackground, Typography } from '@pwskills/rachnaui';
import React from 'react';

type Props = {
  name: string;
  description: string;
  designation: string;
  testimonialImage: string;
  index: number;
};

const TestimonialCard = (props: Props) => {
  const { description, name, designation, testimonialImage, index } = props;

  return (
    <div className="rounded-[8px] border !w-[93%] medium:!w-[400px] regular:!w-[302px] border-stroke-200 px-4 py-2 bg-white flex flex-col justify-between shrink-0 !pl-4 !pt-2 !pb-[10px] !pr-[18px] h-[248px]">
      <div>
        <Typography component="h4" variant="bold" className="text-gray-125">
          {(index + 1).toString().padStart(2, '0')}
        </Typography>
        <Typography
          component="body-regular"
          variant="regular"
          className="text-gray-650 line-clamp-5"
        >
          {description}
        </Typography>
      </div>
      <div>
        <div className="mb-[27px] mt-3" />
        <div className="flex gap-[10px] items-center ">
          {testimonialImage ? (
            <img
              src={`${companyImage}/testimonialImage/${testimonialImage}`}
              alt={name}
              width={42}
              height={42}
              className="object-cover w-[40px] h-[40px] rounded-[50%]"
            />
          ) : (
            <ProfileImageBackground firstName={name} lastName="" />
          )}

          <div>
            <Typography component="body-regular" variant="semi-bold" className="text-gray-850">
              {name}
            </Typography>
            <Typography className="text-gray-650" component="body-regular" variant="regular">
              {designation}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
